// extracted by mini-css-extract-plugin
module.exports = {"widget":"ToggleButton_widget__2tzFp","isSelected":"ToggleButton_isSelected__2fUSL"};